module.exports = __webpack_public_path__ + "static/media/item_sli_demote_des.3f2f3335.png";